import React, { FC, Fragment, useContext, useState } from 'react';

import { Button, CourseWrapper, FlexRowSpaceEvenly } from '../../common-styles/common-styles';
import { Course, Match } from '../../../../database.schema';

import { ScoreCard } from './score-card';
import { UpdateButton } from './update-button';
import { isLoggedIn } from '../../../app/authentication/auth';
import { SelectedIndexContext } from '../../../App';
import { useNavigate } from 'react-router-dom';

export type Hole = {
  hole: number;
  par: number;
  strokeIndex: number;
  score: number;
  points: number;
};
type ScoreCardProps = {
  startingHole: number;
  recordedMatch: Match;
  course: Course;
  showScoreEntry: (value: boolean) => void;
  matchIndex: number;
  resultIndex: number;
  format: 'Pairs' | 'Singles';
};

export const MatchScoreCard: FC<ScoreCardProps> = ({ startingHole, recordedMatch, course, resultIndex, matchIndex, format }): JSX.Element => {
  const navigate = useNavigate();
  const [updateStatus, setUpdateStatus] = useState({ success: false, error: false });
  const { selectedTournamentIndex } = useContext(SelectedIndexContext);

  return (
    <Fragment>
      <h2>ScoreCard</h2>
      <CourseWrapper>Course: {course.name}</CourseWrapper>
      {updateStatus.error && <div>Update failed!!!!</div>}
      <ScoreCard startingHole={startingHole} recordedMatch={recordedMatch} course={course} format={format} />
      <FlexRowSpaceEvenly>
        {isLoggedIn() && (
          <UpdateButton
            course={course}
            startingHole={startingHole}
            resultIndex={resultIndex}
            selectedTournamentIndex={selectedTournamentIndex}
            matchIndex={matchIndex}
            recordedMatch={recordedMatch}
            setUpdateStatus={setUpdateStatus}
          />
        )}
        <Button onClick={() => navigate(`/edit-results/${selectedTournamentIndex}/${resultIndex}`)}>Back</Button>
      </FlexRowSpaceEvenly>
    </Fragment>
  );
};
